import React from "react";
import {useTranslation} from "react-i18next";
import {Flags} from "../components/Flags";
import {
    Box,
    Button,
    Container,
    IconButton,
    Menu,
    MenuItem,
    Paper,
    Typography,
} from "@mui/material";
import {Language as LanguageIcon, SearchOff as SearchOffIcon} from "@mui/icons-material";
import {useNavigate} from "react-router-dom";

const NotFound = () => {
    const {t, i18n} = useTranslation();
    const navigate = useNavigate();
    const role = localStorage.getItem("role") || sessionStorage.getItem("role");

    const roleDefaultPage = {
        ADMIN: "/app/users",
        RESELLER: "/app/makmini",
        CUSTOMER: "/app",
    }[role] || "/";

    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleMenuOpen = (e) => setAnchorEl(e.currentTarget);
    const handleMenuClose = () => setAnchorEl(null);
    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
        localStorage.setItem("i18nextLng", lang);
        handleMenuClose();
    };

    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                bgcolor: "#f5f5f5",
                position: "relative",
            }}
        >
            <Container maxWidth="xs">
                <Paper
                    elevation={2}
                    sx={{
                        p: 4,
                        bgcolor: "white",
                    }}
                >
                    <Box sx={{display: "flex", justifyContent: "flex-end", mb: 2}}>
                        <IconButton
                            onClick={handleMenuOpen}
                            sx={{
                                border: "1px solid",
                                borderColor: "divider",
                            }}
                        >
                            <LanguageIcon/>
                        </IconButton>
                    </Box>

                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleMenuClose}
                        anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                        transformOrigin={{vertical: "top", horizontal: "right"}}
                    >
                        <MenuItem
                            onClick={() => changeLanguage("tr")}
                            selected={i18n.language === "tr"}
                            sx={{gap: 1}}
                        >
                            {Flags.tr}
                            <Typography variant="body2">{t("trLan")}</Typography>
                        </MenuItem>
                        <MenuItem
                            onClick={() => changeLanguage("en")}
                            selected={i18n.language === "en"}
                            sx={{gap: 1}}
                        >
                            {Flags.gb}
                            <Typography variant="body2">{t("enLan")}</Typography>
                        </MenuItem>
                    </Menu>

                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: 72,
                            height: 72,
                            borderRadius: "50%",
                            bgcolor: "warning.light",
                            color: "warning.dark",
                            mx: "auto",
                            mb: 3,
                        }}
                    >
                        <SearchOffIcon fontSize="large"/>
                    </Box>

                    <Box sx={{textAlign: "center"}}>
                        <Typography
                            variant="h5"
                            component="h1"
                            sx={{
                                fontWeight: 700,
                                color: "primary.main",
                                mb: 1,
                            }}
                        >
                            {t("notFound.title")}
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{mb: 3}}>
                            {t("notFound.description")}
                        </Typography>
                    </Box>

                    <Button
                        variant="contained"
                        onClick={() => navigate(roleDefaultPage)}
                        fullWidth
                        sx={{
                            mt: 1,
                            py: 1.25,
                            textTransform: "none",
                            fontWeight: 600,
                        }}
                    >
                        {t("notFound.backToHome")}
                    </Button>

                    <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{
                            display: "block",
                            textAlign: "center",
                            mt: 3,
                        }}
                    >
                        © 2026 Maksi Filtrasyon
                    </Typography>
                </Paper>
            </Container>
        </Box>
    );
};

export default NotFound;
